import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { EffectsModule } from "@ngrx/effects";
import { StoreModule } from "@ngrx/store";
import { PaymentsEffects, PaymentReducer, PaymentStateFeatureKey } from "./store";

@NgModule({
  imports: [
    CommonModule,
    StoreModule.forFeature(PaymentStateFeatureKey, PaymentReducer),
    EffectsModule.forFeature([PaymentsEffects]),
  ]
})

export class PaymentPageDataAccessModule {};
